<template>
  <div>
    <LocalLoader v-if="!isGlobal">
      <slot />
    </LocalLoader>
    <MultiLoader v-else />
  </div>
</template>

<script lang="ts">
import { LocalLoader, MultiLoader } from './ui';

export default {
  name: 'EpkLoader',
  components: {
    LocalLoader,
    MultiLoader,
  },
  props: {
    isGlobal: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
